import { AnimatePresence, motion } from 'motion/react';

import { useCheckQueryStatus } from './hooks/useCheckQueryStatus';
import { ModalCloseButton } from './ModalCloseButton';

import { ProgressBar } from '@/shared/components/progress-bar';
import { Button } from '@/shared/components/shadcn/button';

interface QueryBuilderModalProps {
  isOpen: boolean;
  onClose?: () => void;
  unmount: () => void;
  queryId: string;
  workspaceId: string;
}

export function QueryStatusModal({
  isOpen,
  onClose,
  queryId,
  workspaceId,
}: QueryBuilderModalProps) {
  const { data: queryStatus } = useCheckQueryStatus(workspaceId, queryId);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="w-full max-w-[420px] overflow-hidden rounded-lg bg-white shadow-sm"
          >
            <div className="relative flex h-full flex-col gap-4 p-6">
              <ModalCloseButton className="absolute top-4 right-4 z-10" onClick={onClose} />
              <div className="flex flex-col gap-1.5">
                <h1 className="text-lg font-bold">AI status</h1>
                <p className="text-muted-foreground text-sm">
                  AI is processing the latest scraped posts to deliver accurate insights.
                </p>
              </div>
              <div className="flex flex-col gap-3">
                <div className="flex justify-between">
                  <span className="text-muted-foreground text-sm">Post analyzed</span>
                  <span className="text-muted-foreground text-sm">
                    {queryStatus?.progress ?? 0}%
                  </span>
                </div>
                <ProgressBar progress={queryStatus?.progress ?? 0} barClassName="bg-primary" />
              </div>
              <div className="flex justify-end">
                <Button onClick={onClose}>Close</Button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
